export const CODE_VERSION_CHANGE = 'CODE_VERSION_CHANGE';

export type CodeVersionState = {
  versionId?: string;
};
